<div class="w-full h-6/7 flex flex-col bg-[#11182B]">
	<div #top></div>
	@if(!enableChilds){
		<!-- Menu padre -->
		<!-- Header fijo -->
		<div class="sticky top-0 bg-[#11182B]">
			<div class="app-sidebar-header flex flex-0 items-center justify-start cursor-pointer">
				<button class="back-menu" (click)="onClose()">
					<mat-icon class="icon-size-[18px] font-semibold text-white" svgIcon="heroicons_outline:chevron-double-left"></mat-icon>Regresar a menú prinicipal
				</button>
			</div>
			<div class="categories-container flex flex-row items-center">
				@if(type == 'brands'){
					<mat-icon [svgIcon]="'heroicons_outline:tag'"></mat-icon>
				} @else {
					<mat-icon [svgIcon]="'heroicons_outline:shopping-bag'"></mat-icon>
				}
				<h1 class="title-name ml-[16px]"> {{ type == 'brands' ? 'Marcas' : 'Categorías' }}</h1>
			</div>
		</div>
		<!-- Contenido scrollable -->
		<div class="h-full overflow-y-auto">
			<div class="categories-container flex-0">
				@if (type == "brands"){
				@for (brand of brands; track brand) {
				<div class="category-item" (click)="onCategoryClick(brand.code)" [class.active]="filterBrand?.includes(brand.code)">
					<div class="category-name cursor-pointer">{{ brand.name }}</div>
				</div>
				}
				}
				@if (type == "categories"){
				@for (category of categories; track category) {
				<div class="category-item" (click)="onCategoryClick(category.id)"
					[class.active]="filterCategory?.includes(category.id)">
					<div class="category-name cursor-pointer">{{ category.name }}</div>
					@if (category.childs?.length > 0){
					<mat-icon class="icon-size-[16px]" svgIcon="heroicons_outline:chevron-right"></mat-icon>
					}
				</div>
				}
				}
			</div>
		</div>
	}
	@if(enableChilds){
		<!-- Menu hijos -->
		<!-- Header fijo -->
		<div class="sticky top-0 bg-[#11182B]" [class.show]="enableChilds">
			<div class="app-sidebar-header flex flex-0 items-center justify-start cursor-pointer">
				<button class="back-menu" (click)="onCloseChilds()">
					<mat-icon class="icon-size-[18px] font-semibold text-white" svgIcon="heroicons_outline:chevron-double-left"></mat-icon>Regresar a {{ titleChild ? type ==
					'brands' ? 'Marcas' : 'Categorías': "menú prinicipal" }}
				</button>
			</div>
			<div class="categories-container-chids flex flex-row items-center w-full">
				@if(type == 'brands'){
				<mat-icon [svgIcon]="'heroicons_outline:tag'"></mat-icon>
				} @else {
				<mat-icon [svgIcon]="'heroicons_outline:shopping-bag'"></mat-icon>
				}
				<h1 class="title-name ml-[16px]"> {{ type == 'brands' ? 'Marcas' : 'Categorías' }} - {{ titleMain }}</h1>
			</div>
		</div>
		<!-- Contenido scrollable -->
		<div class="h-full overflow-y-auto">
			<div class="categories-container flex-0">
				@for (child of childs; track child) {
				<div class="category-item" (click)="onCategoryClick(child.id, true)"
					[class.active]="filterCategory?.includes(child.id)">
					<div class="category-name cursor-pointer">{{ child.name }}</div>
				</div>
				}
			</div>
		</div>
	}
</div>